import * as apiGetStartingWith from 'api/tag/GetTagStartingWithV1';
import { ISelectItem } from 'interfaces/ISelectItem';
import * as Tag from 'types/BaseIngredient/Search/Tag';
import * as Icon from 'types/Icon/Icon';

export type Type = Tag.Type[];

export function create(): Type {
	return [];
}

export async function getFromApiSW(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<ISelectItem[]> {
	const response = await apiGetStartingWith.callApi(searchTerm, showOnlyDeleted);
	const responseData = response.toNullable();
	if (responseData) return mapToISelectItem(responseData);
	return [];
}

export function mapToIcons(obj: Type): (Icon.Type | null)[] {
	return obj.map((t: Tag.Type) => {
		return Tag.mapToIcon(t);
	});
}

export function mapToISelectItem(input: apiGetStartingWith.ResponseTag[]): ISelectItem[] {
	return input.map<ISelectItem>((x: apiGetStartingWith.ResponseTag) => ({
		id: x.id,
		name: x.name,
	}));
}
